import { ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NToggle, ToggleService } from '@df/ui/toggle/toggle.service';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { AppRootComponent } from '../../../app-root.component';
import { IconButtonComponent } from '../../../common/buttons/icon-button/icon-button.component';
import { AbstractPageSearchFormComponent } from '../../search/form/abstract-page-search-form.component';
import { NPageSearch } from '../../search/page-search.interfaces';
import { NPageOffCanvas } from '../page-off-canvas.component';

@Component({
    imports: [FormsModule, IconButtonComponent, TranslatePipe],
    selector: 'page-off-canvas-search-form',
    templateUrl: './page-off-canvas-search-form.html',
    styleUrl: './page-off-canvas-search-form.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageOffCanvasSearchFormComponent extends AbstractPageSearchFormComponent implements OnInit {
    @ViewChild('input', { read: ElementRef })
    protected input?: ElementRef<HTMLInputElement>;

    static get toggleId(): NToggle.TId {
        return [NPageOffCanvas.OFF_CANVAS_GROUP_ID, NPageSearch.SEARCH_OFF_CANVAS_KEY];
    }

    private readonly appRootComponent = inject(AppRootComponent);
    private readonly toggleService = inject(ToggleService);

    override ngOnInit(): void {
        this.subscriptions.add(
            this.appRootComponent.offCanvasState.subscribe(state => {
                if (!state) {
                    this.toggleVisibility(false);
                }
            })
        );
        this.subscriptions.add(
            this.toggleService.getState(PageOffCanvasSearchFormComponent.toggleId).subscribe(value => this.toggleVisibility(value))
        );
        super.ngOnInit();
    }

    /**
     * Toggle full component visibility
     */
    toggleVisibility(to: boolean) {
        if (this.isVisible !== to) {
            this.isVisible = to;
            if (to) {
                this.toggleService.open(PageOffCanvasSearchFormComponent.toggleId);
                this.input?.nativeElement.focus();
            } else {
                this.toggleService.close(PageOffCanvasSearchFormComponent.toggleId);
                this.reset();
            }
        }
    }
}
